export const REQUEST_SECURITY_ASSESSMENT_DATA = "REQUEST_SECURITY_ASSESSMENT_DATA";
export const RECEIVE_SECURITY_ASSESSMENT_DATA = "RECEIVE_SECURITY_ASSESSMENT_DATA";

export interface ISecurityAssesmentState {
    assessmentData?: IAssessmentData;
    isLoading: boolean;
}

export interface IAssessmentData {
    Percentage?: number;
    Rating?: string;
    listPendingAction: IPendingAction[];
    TotalOpenAction: string;
    questions?: any[];
}

export interface IPendingAction {
    Id?: number;
    ParentID?: number;
    QuestionText?: string;
    ActionText?: string;
    Ordinal?: number;
    Score?: number;
    AlternateText?: string;
    IsDeleted?: boolean;
    ProductID?: number;
    childQuestions?: any;
}

export interface IHtmlItem {
    title: string;
    htmlDesc: any;
}

//==============Questionaires======//

export interface IQuestionairesResponseData {
    Questions?: IQuestionaires[];
    HasError?: boolean;
    ErrorText?: string[];
}

export interface IQuestionaires {
    Id?: string;
    Title?: string;
    Details?: string;
    Question?: string;
    AnswerSchema?: IDetailQuestionaires;
    answer?: string;
}

export interface IDetailQuestionaires {
    Question?: string;
    AnswerSchema?: IDetailAnswerSchema[];
}

export interface IDetailAnswerSchema {
    Id?: string;
    Title?: string;
    Details?: string;
    ParentID?: string;
    answer?: string;
}

export interface IGetAssessmentDataAction {
    type: "RECEIVE_SECURITY_ASSESSMENT_DATA";
    assessmentData: IAssessmentData;
}
export interface IRequestAssessmentDataAction {
    type: "REQUEST_SECURITY_ASSESSMENT_DATA";
}

export type SecurityAssesmentTypes = IGetAssessmentDataAction | IRequestAssessmentDataAction;
